import { svg } from 'lit';

export const tagFilledIcon = svg`
  <path fill-rule="evenodd" clip-rule="evenodd" d="M3 2C2.44772 2 2 2.44772 2 3V12C2 12.2737 2.11216 12.5354 2.31034 12.7241L12.8103 22.7241C13.2034 23.0985 13.8233 23.0909 14.2071 22.7071L22.7071 14.2071C23.0909 13.8233 23.0985 13.2034 22.7241 12.8103L12.7241 2.31034C12.5354 2.11216 12.2737 2 12 2H3ZM6 8.5C6 7.11929 7.11929 6 8.5 6C9.88071 6 11 7.11929 11 8.5C11 9.88071 9.88071 11 8.5 11C7.11929 11 6 9.88071 6 8.5Z" fill="currentColor"/>
  `;
